import xhr from "../Helper/axiosInterceptor";

import {
  URL_LOGIN,
  URL_LOGIN_V2,
  URL_VERIFY_OTP,
  URL_RESEND_OTP,
  URL_LOGOUT,
  URL_REGISTER,
  URL_CHANGE_PASSWORD,
  URL_FORGOT_PASSWORD,
  URL_VERIFY_USER,
  URL_GET_CLINIC,
  URL_VERIFY_EDC_MEMBER,
  URL_VERIFY_EDC_MEMBER_EMPLOYEE,
  URL_GET_ALL_USER,
  URL_REGISTER_EDC_MEMBER,
  URL_GET_DIAGNOSTIC,
  URL_CHECKOUT_PAYMENT,
  URL_CLAIM_ITEM,
  URL_CALCULATE_ITEM,
  URL_VERIFY_EDC_MEMBER_DOB,
  URL_INQUIRY_PAYMENT,
  URL_VOID_CLAIM,
  URL_CREATE_TRANSACTION,
  URL_GETALL_TRANSACTION,
  URL_GET_FILTER_TRANSACTION,
  URL_GET_PER_TRANSACTION_ALL,
  URL_GET_PER_TRANSACTION_FILTER,
  URL_SEARCH_TRANSACTION_BY_TRACE_NO,
  URL_GET_ICD_ALL,
  URL_ICD_SEARCH,
  URL_GET_USERS_BY_PROVIDER_NAME,
  URL_GET_CLAIM_LOCKED_STATUS,
  URL_PUT_CHANGE_STATUS_LOCKED_CLAIM,
  URL_TRANSACTION_Payment,
  URL_UPLOAD,
  URL_GET_LISTDOC,
  URL_DELETE_Doclist,
  URL_DELETE_FILE,
  URL_GET_PAYMENTBYDATE,
  URL_GET_EMPLOYEE_DATA,
  URL_POST_NEW_FACE_ID,
  URL_GET_ALL_FACE,
  URL_GET_ONE_CLINIC,
  URL_SEARCH_PAYMENT,
  URL_GET_PAYMENTINVOICE,
  URL_GET_CAPTCHA,
  URL_GET_CAPTCHA_V2,
  URL_VERIFY_CAPTCHA,
  URL_CREATEINV,
  URL_INVOICE_EDIT,
  URL_LIST_INVOICE_EDIT,
  URL_EDITINVOICE,
  URL_FIND_INVOICENUMBER,
  URL_UPDATE_USERNAME,
  URL_PAYMENT_TRANSACTION,
  URL_DOC_FORM,
  URL_FONE_CHECK_ELIGIBILITY,
  URL_REGISTER_FONE,
  URL_EXCLUSION_FONE,
  URL_SUBMIT_CLAIM_FONE,
  URL_F1_SSO,
  RegisterFinger,
  URL_CHECK_SESSION,
  FindByFinger,
  FIND_UNID,
  FIND_FINGER_UNID,
} from "../Config/Api";

export const registerFone = (data) => {
  return xhr(URL_REGISTER_FONE, "post", data);
};

export const ssoFone = (data) => {
  const { clinicId, clinicCategory, providerName } = data;
  return xhr(
    URL_F1_SSO,
    "get",
    {},
    {},
    undefined,
    { clinicId, clinicCategory, providerName },
    false,
  );
};

export const submitClaimFone = (data) => {
  return xhr(URL_SUBMIT_CLAIM_FONE, "post", data);
};

export const exclusionFone = (data) => {
  return xhr(URL_EXCLUSION_FONE, "post", data);
};
export const checkEgibilityFone = (data) => {
  return xhr(URL_FONE_CHECK_ELIGIBILITY, "post", data);
};

export const GetDocForm = (data) => {
  return xhr(
    URL_DOC_FORM.replace("params", data).replace("param", data.id),
    "get",
    {},
  );
};

export const checkSession = (data) => {
  return xhr(URL_CHECK_SESSION, "get", null, undefined, undefined, data);
};
export const fingerPrintMatchByCard = (data) => {
  return xhr(FIND_UNID, "post", data);
};

export const fingerPrintUnid = (data) => {
  return xhr(FIND_FINGER_UNID, "post", data);
};

export const fingerPrintMatch = (data) => {
  return xhr(FindByFinger, "post", data);
};
export const fingerPrintRegister = (data) => {
  return xhr(RegisterFinger, "post", data);
};

export const Update_username = (data) => {
  return xhr(URL_UPDATE_USERNAME, "patch", data);
};

export const FIND_INVOICENUMBER = (data) => {
  return xhr(URL_FIND_INVOICENUMBER, "post", data);
};

export const EDIT_INVOICE = (data) => {
  return xhr(URL_EDITINVOICE, "patch", data);
};

export const LIST_INVOICE_EDIT = (data) => {
  return xhr(URL_LIST_INVOICE_EDIT, "post", {
    InvoiceNumber: data.InvoiceNumber,
    providerCode: data.providerCode,
    id: data.id,
  });
};

export const CreateINV = (data) => {
  return xhr(URL_CREATEINV, "post", {
    InvoiceNumber: data.InvoiceNumber,
    ClaimNumber: data.ClaimNumber,
    id: data.id,
  });
};

export const INV_TOEDIT = (data) => {
  return xhr(URL_INVOICE_EDIT, "post", {
    InvoiceNumber: data.InvoiceNumber,
    pageno: data.pageno,
    id: data.id,
    providerCode: data.providerCode,
  });
};

export const TransactionPayment = (data) => {
  return xhr(
    URL_TRANSACTION_Payment.replace("params", data.providerCode)
      .replace("param2", data.id)
      .replace(":page", data.page),
    "get",
    {},
  );
};

export const PAYMENT_TO_INVOICE = (data) => {
  return xhr(URL_GET_PAYMENTINVOICE + `/${data.pageno}`, "post", {
    providerCode: data.providerCode,
    // data.CardNo,
    // data.Claimid,
    // StartDate: data.StartDate,
    // EndDate: data.EndDate,
    id: data.id,
  });
};

export const SearchPayment = (data) => {
  return xhr(URL_SEARCH_PAYMENT, "post", {
    id: data.id,
    providerCode: data.providerCode,
    StartDate: data.StartDate,
    EndDate: data.EndDate,
    CardNo: data.CardNo,
    Claimid: data.Claimid,
    pageno: data.pageno,
  });
};
export const PaymentByDate = (data) => {
  return xhr(URL_GET_PAYMENTBYDATE, "post", {
    providerCode: data.providerCode,
    // data.CardNo,
    // data.Claimid,
    StartDate: data.StartDate,
    EndDate: data.EndDate,
    id: data.id,
  });
};

export const DeleteDoclist = (data) => {
  return xhr(URL_DELETE_Doclist, "delete", {
    claimid: data.value.claimid,
    file_name: data.value.file_name,
    id: data.id,
  });
};
export const DeleteFile = (data) => {
  return xhr(
    URL_DELETE_FILE.replace("claimID", data.value.claimid).replace(
      "ID",
      data.value.id,
    ),
    "delete",
    {},
  );
};

export const getListdoc = (data) => {
  return xhr(URL_GET_LISTDOC.replace("CLAIMID", data), "get", {});
};

export const upload = (data) => {
  let tanggal = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  return xhr(
    URL_UPLOAD.replace("param1", data.ClientID)
      .replace("param2", data.CoyId)
      .replace("param3", tanggal.slice(6, 10))
      .replace("param4", tanggal.slice(3, 5))
      .replace("param5", tanggal.slice(0, 2))
      .replace("param6", data.providerCode)
      .replace("param7", data.claimid),
    "post",
    data.formData,
  );
};

export const login = (formLogin) => {
  return xhr(URL_LOGIN, "post", formLogin);
};

export const loginv2 = (formLogin) => {
  return xhr(URL_LOGIN_V2, "post", formLogin, undefined, 30000);
};

export const verifyOtp = (params) => {
  let { otpCode, loginId } = params;
  return xhr(
    URL_VERIFY_OTP.replace("param1", otpCode).replace("param2", loginId),
    "get",
    {},
  );
};

export const resendOtp = (params) => {
  let { loginId, deviceId, token } = params;
  return xhr(
    URL_RESEND_OTP.replace("param1", loginId)
      .replace("param2", deviceId)
      .replace("param3", token),
    "get",
    {},
  );
};

export const logout = (data) => {
  return xhr(URL_LOGOUT, "post", data);
};

export const register = (dataRegister) => {
  return xhr(URL_REGISTER, "post", dataRegister);
};

export const changePassword = (data) => {
  return xhr(URL_CHANGE_PASSWORD, "put", data);
};

export const forgotPassword = (data) => {
  return xhr(URL_FORGOT_PASSWORD, "put", data);
};

export const verifyUser = (data) => {
  return xhr(URL_VERIFY_USER, "post", data);
};

export const getAllUser = () => {
  return xhr(URL_GET_ALL_USER, "get", {});
};

export const getClinic = (params) => {
  return xhr(URL_GET_CLINIC.replace("params", params), "get", {});
};

export const verifyMemberEdc = (data) => {
  return xhr(URL_VERIFY_EDC_MEMBER, "post", data);
};

export const verifyEdcMemberByEmployeeId = (employeeId, userId) => {
  const params = { employeeId };
  if (userId) {
    params.id = userId;
  }
  return xhr(
    URL_VERIFY_EDC_MEMBER_EMPLOYEE,
    "get",
    null,
    undefined,
    undefined,
    params,
  );
};

export const registerMemberEdc = (data) => {
  // console.log(data);
  return xhr(URL_REGISTER_EDC_MEMBER, "post", data, {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  });
};

export const getDiagnostic = (data) => {
  return xhr(URL_GET_DIAGNOSTIC, "post", data);
};

export const checkoutPayment = (data) => {
  return xhr(URL_CHECKOUT_PAYMENT, "post", data);
};

export const claimItem = (data) => {
  return xhr(URL_CLAIM_ITEM, "post", data);
};

export const calculateItem = (data) => {
  return xhr(URL_CALCULATE_ITEM, "post", data);
};

export const verifyEdcDob = (data) => {
  return xhr(URL_VERIFY_EDC_MEMBER_DOB, "post", data);
};

export const inquiryPayment = (data) => {
  return xhr(URL_INQUIRY_PAYMENT, "post", data);
};

export const voidClaim = (data) => {
  return xhr(URL_VOID_CLAIM, "post", data);
};

export const getAllTransaction = (params) => {
  return xhr(URL_GETALL_TRANSACTION.replace("params", params), "get", {});
};

export const getUsersByProviderName = (data) => {
  return xhr(
    URL_GET_USERS_BY_PROVIDER_NAME.replace("param", data.providerName),
    "get",
    {},
  );
};

export const getFilterTransaction = (data) => {
  return xhr(
    URL_GET_FILTER_TRANSACTION.replace("param1", data.startDate)
      .replace("param2", data.endDate)
      .replace("param3", data.transactionType)
      .replace("param4", data.providerCode)
      .replace("param5", data.id),
    "get",
    {},
  );
};

export const getPerTransactionAll = (data) => {
  return xhr(
    URL_GET_PER_TRANSACTION_ALL.replace("param1", data.transactionType)
      .replace("param2", data.providerCode)
      .replace("param3", data.id)
      .replace("param4", data.page)
      .replace("param5", data.size),
    "get",
    {},
  );
};

export const searchTransactionByTraceNo = (data) => {
  return xhr(
    URL_SEARCH_TRANSACTION_BY_TRACE_NO.replace("param1", data.traceNo).replace(
      "param2",
      data.id,
    ),
    "get",
    {},
  );
};

export const getPerTransactionFilter = (data) => {
  return xhr(
    URL_GET_PER_TRANSACTION_FILTER.replace("param1", data.startDate)
      .replace("param2", data.endDate)
      .replace("param3", data.transactionType)
      .replace("param4", data.providerCode)
      .replace("param5", data.cardNumber)
      .replace("param6", data.id)
      .replace("param7", data.page)
      .replace("param8", data.size),
    "get",
    {},
  );
};

export const createTransaction = (data) => {
  return xhr(URL_CREATE_TRANSACTION, "post", data);
};

export const getAllIcd = (data) => {
  return xhr(URL_GET_ICD_ALL.replace("param", data.id), "get", {});
};

export const icdSearch = (data) => {
  return xhr(
    URL_ICD_SEARCH.replace("param", data.data).replace("param1", data.id),
    "get",
    {},
  );
};

export const getClaimLocked = (data) => {
  return xhr(
    URL_GET_CLAIM_LOCKED_STATUS.replace("param", data.ProviderCode).replace(
      "param1",
      data.id,
    ),
    "get",
    {},
  );
};

export const putChangeClaimLocked = (data) => {
  return xhr(URL_PUT_CHANGE_STATUS_LOCKED_CLAIM, "put", data);
};

export const getEmployeeData = (data) => {
  return xhr(URL_GET_EMPLOYEE_DATA.replace("param", data), "get", {});
};

export const postEnrollFace = (data) => {
  return xhr(URL_POST_NEW_FACE_ID, "post", data);
};

export const getAllFace = () => {
  return xhr(URL_GET_ALL_FACE, "get", {});
};

export const getOneClinic = (data) => {
  return xhr(URL_GET_ONE_CLINIC.replace("param", data), "get", {});
};

export const getCaptcha = () => {
  return xhr(URL_GET_CAPTCHA, "get", {});
};

export const getCaptchaV2 = (data) => {
  return xhr(URL_GET_CAPTCHA_V2.replace("param", data), "get", {});
};

export const verifyCaptcha = (data) => {
  return xhr(URL_VERIFY_CAPTCHA, "post", data);
};

export const OnePaymentTransaction = (data) => {
  return xhr(URL_PAYMENT_TRANSACTION, "post", data);
};
